import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import { faScreenUsers } from '@fortawesome/pro-light-svg-icons'
import { ListLMCTextContainer } from '../../App/Components/LastMinuteListHeader/style'
import {
  ListColor,
  ListCardText,
  ListCardTitle,
  ListCardDate,
} from '../../App/Components/ListCard/style'
import { CardNavWrapper } from '../../App/Components/ListCard/CardNavWrapper'
import { stringToHsl } from '../../App/Util'
import { CategorySection } from '../../ExtraActivity/Components/ListStructure/Components/CategorySection/CategorySection'
import { useAppSelector } from '../../store/hooks'
import { useParams } from '../../Router'

/**
 * OB-506: row layout for the workshop list item. The previous
 * ListLMContainer (a styled.button) owned this layout; the CardNavWrapper
 * <a> is display:block, so the dot + text need their own flex-row parent.
 */
const RowLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 35px 5px 15px;
  margin: 15px 0;
  width: 100%;
`

type Props = {
  title: string
  image?: string
}

export const WorkshopListView: React.FC<Props> = ({ title, image }) => {
  const { workshops, settings } = useAppSelector((state) => ({
    settings: state.settings.values,
    workshops: state.workshops.list,
  }))

  const { establishmentId } = useParams<{ [key: string]: string }>()

  const { fontColor, highlightColor, backgroundColor } = settings

  let customImage: string | undefined
  if (image) {
    customImage = image
    if (typeof image === 'string' && image.includes('?id=')) {
      customImage += '&w=48&h=48&fit=crop'
    }

    if (typeof image === 'string' && image.startsWith('//')) {
      customImage = `https:${customImage}`
    }
  }

  if (typeof workshops === 'undefined') {
    return null
  }

  const workshopListRender = workshops.map((workshop) => {
    /*
     * OB-506: absolute path so the URL is portable when copied via
     * right-click "Copy Link Address" or long-press "Copy link".
     */
    const bookUrl = `/${establishmentId}/workshops/${workshop.uuid}/book`
    return (
      <CardNavWrapper key={workshop.uuid} navType="workshop" link={bookUrl}>
        <RowLayout>
          <ListColor color={stringToHsl(title, 50, 50)} isChild />
          <ListLMCTextContainer>
            <ListCardTitle highlight={fontColor}>
              {workshop.title}
            </ListCardTitle>
            <ListCardDate highlight={highlightColor}>
              {moment(workshop.startsAt).format('LLLL')}
            </ListCardDate>
            {!workshop.description || (
              <ListCardText fontcolor={fontColor}>
                {workshop.description}
              </ListCardText>
            )}
          </ListLMCTextContainer>
        </RowLayout>
      </CardNavWrapper>
    )
  })

  return (
    <CategorySection
      title={title}
      list={workshopListRender}
      fontcolor={fontColor}
      icon={faScreenUsers}
      highlightColor={highlightColor}
      lastMinuteMenuLine
      bgColor={backgroundColor}
    />
  )
}
